// Developer docs (docs.html) — code samples, tab switching, copy, and scroll-spy.
import "../../shared/design-tokens/tokens.css";
import "./platform.css";
import { mountIcons } from "./icons.js";
import { brand, applyBrand } from "./brand.js";

const SECRET = `${brand.name.toUpperCase()}_SECRET`;
const SESSION_TOKEN = `${brand.name.toUpperCase()}_SESSION_TOKEN`;
const lower = brand.name.toLowerCase();
const API_BASE = `${brand.apiBase.replace(/\/+$/, "").replace(/\/api\/v1$/i, "")}/api/v1`;

const PANES = {
  qs: {
    html: `<span class="tok-tag">&lt;script</span> <span class="tok-key">src</span>=<span class="tok-str">"${brand.cdnBase}/widget.js"</span>
        <span class="tok-key">data-api-base</span>=<span class="tok-str">"${API_BASE}"</span>
        <span class="tok-key">data-tenant-id</span>=<span class="tok-str">"&lt;tenant-id&gt;"</span>
        <span class="tok-key">data-mode</span>=<span class="tok-str">"customer"</span><span class="tok-tag">&gt;&lt;/script&gt;</span>`,
    react: `<span class="tok-key">import</span> { ${brand.name} } <span class="tok-key">from</span> <span class="tok-str">"@${brand.pkgScope}/react"</span>;

<span class="tok-key">export default function</span> <span class="tok-fn">Support</span>() {
  <span class="tok-key">return</span> <span class="tok-tag">&lt;${brand.name}</span> <span class="tok-key">tenant</span>=<span class="tok-str">"acme-health"</span> <span class="tok-key">session</span>={token} <span class="tok-tag">/&gt;</span>;
}`,
    ios: `<span class="tok-key">import</span> ${brand.name}Kit

<span class="tok-key">let</span> chat = <span class="tok-fn">${brand.name}</span>(tenant: <span class="tok-str">"acme-health"</span>, session: token)
present(chat.viewController, animated: <span class="tok-key">true</span>)`,
  },
  drift: {
    html: `<span class="tok-tag">&lt;script&gt;</span>
  (function () {
    var q = (window.drift = window.driftt = window.drift || []);
    if (q.init || q.iris) return;
    [<span class="tok-str">"identify"</span>, <span class="tok-str">"config"</span>, <span class="tok-str">"track"</span>, <span class="tok-str">"reset"</span>, <span class="tok-str">"debug"</span>, <span class="tok-str">"show"</span>, <span class="tok-str">"ping"</span>, <span class="tok-str">"page"</span>, <span class="tok-str">"hide"</span>, <span class="tok-str">"off"</span>, <span class="tok-str">"on"</span>, <span class="tok-str">"load"</span>].forEach(function (name) {
      q[name] = function () { q.push([name].concat([].slice.call(arguments))); };
    });
  })();
<span class="tok-tag">&lt;/script&gt;</span>
<span class="tok-tag">&lt;script</span> <span class="tok-key">src</span>=<span class="tok-str">"${brand.cdnBase}/widget.js"</span>
        <span class="tok-key">data-api-base</span>=<span class="tok-str">"${API_BASE}"</span>
        <span class="tok-key">data-tenant-id</span>=<span class="tok-str">"&lt;tenant-id&gt;"</span>
        <span class="tok-key">data-application-id</span>=<span class="tok-str">"&lt;application-id&gt;"</span>
        <span class="tok-key">data-environment-id</span>=<span class="tok-str">"&lt;environment-id&gt;"</span>
        <span class="tok-key">data-mode</span>=<span class="tok-str">"customer"</span>
        <span class="tok-key">data-drift-compat</span>=<span class="tok-str">"true"</span> <span class="tok-key">defer</span><span class="tok-tag">&gt;&lt;/script&gt;</span>`,
  },
  ex: {
    req: `curl ${API_BASE}/channels/ch_8841/messages \\
  -H <span class="tok-str">"Authorization: Bearer $${SESSION_TOKEN}"</span> \\
  -H <span class="tok-str">"Content-Type: application/json"</span> \\
  -d <span class="tok-str">'{ "content": "A fresh secure link is on its way." }'</span>`,
    res: `{
  <span class="tok-key">"message_id"</span>: <span class="tok-str">"m_5c2f"</span>,
  <span class="tok-key">"channel_id"</span>: <span class="tok-str">"ch_8841"</span>,
  <span class="tok-key">"sender_id"</span>: <span class="tok-str">"operator_42"</span>,
  <span class="tok-key">"content"</span>: <span class="tok-str">"A fresh secure link is on its way."</span>,
  <span class="tok-key">"created_at"</span>: <span class="tok-str">"2026-06-02T14:21:08Z"</span>
}`,
  },
};

const TOK = `<span class="tok-key">import</span> { ${brand.name} } <span class="tok-key">from</span> <span class="tok-str">"@${brand.pkgScope}/node"</span>;
<span class="tok-key">const</span> ${lower} = <span class="tok-fn">${brand.name}</span>(process.env.${SECRET});

<span class="tok-key">const</span> { token } = <span class="tok-key">await</span> ${lower}.sessions.<span class="tok-fn">create</span>({
  tenant: <span class="tok-str">"acme-health"</span>,
  user: { ref: <span class="tok-str">"patient_8841"</span>, name: <span class="tok-str">"Jordan Meyer"</span> }
});`;

function initTabs() {
  document.querySelectorAll("[data-tabs]").forEach((grp) => {
    const key = grp.dataset.tabs;
    const pane = document.querySelector(`[data-pane="${key}"]`);
    if (!pane) return;
    const set = (l) => {
      pane.innerHTML = PANES[key][l];
      grp.querySelectorAll("button").forEach((b) => b.classList.toggle("on", b.dataset.l === l));
    };
    grp.querySelectorAll("button").forEach((b) => (b.onclick = () => set(b.dataset.l)));
    set(grp.querySelector("button").dataset.l);
  });
  const tokpane = document.getElementById("tokpane");
  if (tokpane) tokpane.innerHTML = TOK;
}

function initCopy() {
  document.querySelectorAll(".pf-copy").forEach((btn) => {
    btn.onclick = () => {
      const pre = btn.closest(".pf-codeblock").querySelector("pre");
      navigator.clipboard && navigator.clipboard.writeText(pre.textContent);
      btn.textContent = "Copied";
      setTimeout(() => (btn.textContent = "Copy"), 1400);
    };
  });
}

function initSpy() {
  const links = [...document.querySelectorAll(".docs__lnk")];
  const map = {};
  links.forEach((l) => (map[l.getAttribute("href").slice(1)] = l));
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          links.forEach((l) => l.classList.remove("on"));
          const l = map[en.target.id];
          if (l) l.classList.add("on");
        }
      });
    },
    { rootMargin: "-80px 0px -70% 0px" },
  );
  document.querySelectorAll(".docs__sec").forEach((s) => obs.observe(s));
}

applyBrand();
initTabs();
initCopy();
initSpy();
mountIcons();
